export const nameOnCardValidation = value => {
  if (!value) {
    return { nameOnCard: '*Required' };
  } else if (!/^[a-zA-Z._-\s,'&]+$/.test(value)) {
    return { nameOnCard: '*Invalid name value' };
  }
  return {};
};

export const fullNameValidation = value => {
  if (!value) {
    return { fullName: '*Required' };
  } else if (!/^[a-zA-Z._-\s,'&]+$/.test(value)) {
    return { fullName: '*Invalid name value' };
  }
  return {};
};



// WEBPACK FOOTER //
// ./src/components/Forms/Validations/nameOnCardValidation.js